import { isEqual, isObject } from 'lodash/fp'
import { reduce } from 'lodash'

import type { FilterItem } from 'types/FilterBuilder'
import type { Meta, Participant as ParticipantType } from 'types/Participants'

export const createFiltersArray = (filters: any) => {
  const filtersArray: any = []

  filters.forEach((filter: any) => {
    if (filter.value) {
      const data = {
        condition: filter.condition,
        fieldName: filter.fieldName,
        value: filter.value,
      }

      filtersArray.push(data)
    }
    // For last seen filter and joined date
    else if (filter.startDate && filter.endDate) {
      const before = {
        condition: 'before',
        fieldName: filter.fieldName,
        value: filter.endDate,
      }

      const after = {
        condition: 'after',
        fieldName: filter.fieldName,
        value: filter.startDate,
      }

      filtersArray.push(before)
      filtersArray.push(after)
    }
  })

  return filtersArray
}

export const getKey = (record: ParticipantType) => {
  const { blocked, confirmed, roleName } = record
  if (blocked) return 'blocked'
  if (confirmed && roleName === 'project_admin') return 'admin'
  if (confirmed) return 'active'
  return 'notFound'
}

export const getRowPerPageOptions = (meta: Meta) => {
  const { count: totalRecords } = meta

  const start = 25
  const options = [start]
  let count = 2
  let option = 0

  while (option <= totalRecords) {
    option = count * start
    if (option <= 100 && option <= totalRecords) {
      options.push(option)
    } else {
      return options
    }

    count++
  }

  return options
}

export const objectDifference = (object: any, base: { [x: string]: any }) => {
  return reduce(
    object,
    (result: any, value: any, key: any): any => {
      if (base && !isEqual(value, base[key])) {
        result[key] =
          isObject(value) && isObject(base[key])
            ? objectDifference(value, base[key])
            : value
      }
      return result
    },
    {},
  )
}

export const makeDefaultOpenFilterFalse = (filters: FilterItem[]) => {
  const newFiltersToSet: FilterItem[] = []
  filters.forEach(function (filter: FilterItem) {
    const newFilterObj = { ...filter }
    newFilterObj.defaultOpen = false
    newFiltersToSet.push(newFilterObj)
  })
  return newFiltersToSet
}
